import { apiConfigs } from "../../constants/apiConfigs"
import { Address, Coordinates, SavedAddress } from "../../types/address"
import axiosClient from "../../utils/axiosClient"

export const getReverseGeocode = async (coords: Coordinates) => {
    const response = await axiosClient.get(`/i/address/geocode?latlng=${coords.latitude},${coords.longitude}`)
    return response.data.results
}

export const fetchPlaces = async (searchQuery: string, coords: Coordinates) => {
    const response = await axiosClient.post(apiConfigs.FETCH_MAP_PLACES.url, {
        input: searchQuery,
        lat: coords.latitude,
        lng: coords.longitude
    })

    return response.data.suggestions;
}

export const fetchPlace = async (placeId: string) => {
    const response = await axiosClient.get(apiConfigs.FETCH_PLACE.url.replace('<placeId>', placeId))

    return response.data;
}

export const storeAddress = async (address: Address) => {
    const response = await axiosClient.post(apiConfigs.STORE_ADDRESS.url, address);
    return response.data;
}

export const fetchAdresses = async () => {
    const response = await axiosClient.get(apiConfigs.FETCH_ADDRESSES.url);
    return response.data.items as SavedAddress[];
}

export const fetchAddress = async (addressId: string) => {
    const response = await axiosClient.get(apiConfigs.FETCH_ADDRESS.url.replace('<addressId>', addressId));
    return response.data?.address as SavedAddress;
}

export const fetchDecodedAddress = async (place_id: string) => {
    const response = await axiosClient.get(apiConfigs.FETCH_PLACE_LOCAL.url, {params: {place_id}});
    return response.data.address as Address;
}